import { MessageIncomingEvent, isCallMessage, isTextMessage, isConferenceEditMessage } from '@wui/im'
import { computed, unref, type ComputedRef, type MaybeRef } from 'vue'

import { useVoiceMessageStore } from '@/entities/voice-message'

import { RoomListItem } from '@/shared/types/app'

import * as EventPreview from './event-preview'


export function useRoomPreview (room: MaybeRef<RoomListItem | undefined>): ComputedRef | undefined {
  return computed(() => {
    const roomValue = unref(room)
    if (!room) return
    const hasVoiceDraft = roomValue?.pServedUser
      ? Boolean(useVoiceMessageStore().getSession(roomValue.pServedUser))
      : false
    if (
      hasVoiceDraft ||
      roomValue?.draft?.messageText ||
      roomValue?.draft?.quotedEventId ||
        (roomValue?.draft?.files && roomValue?.draft?.files.length > 0)
    ) return EventPreview.DraftPreview

    const lastMessage = roomValue?.lastMessage
    if (!lastMessage) {
      return EventPreview.NullPreview
    }
    if (isCallMessage(lastMessage)) {
      return EventPreview.CallPreview
    }
    if (isConferenceEditMessage(lastMessage)) {
      return EventPreview.ConferenceEditPreview
    }
    if (isTextMessage(lastMessage)) {
      if ((lastMessage.item as MessageIncomingEvent).forwarding?.forwardingEventId) {
        return EventPreview.ForwardMessagePreview
      }
      if (lastMessage.item.files?.length) {
        return EventPreview.FilesPreview
      }
      return EventPreview.DefaultPreview
    }
    if (lastMessage.item.type === 'ReactionAddedEvent') {
      return EventPreview.ReactionPreview
    }

    if (lastMessage.item.type === 'PinnedMessageEvent') {
      return EventPreview.PinMessagePreview
    }

    return EventPreview.NullPreview
  })
}
